import "../_namespaces.js";
import "#vendor/humps.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.Base = class Base extends Backbone.View {
  // EVENT HANDLERS

  constructor() {
    super(...arguments);
    this.handleAttributeChange = this.handleAttributeChange.bind(this);
  }

  handleAttributeChange(event) {
    const input = jQuery(event.target);
    return this.model.set(humps.camelize(input.attr("name")), input.val());
  }
};
